export default __webpack_public_path__ + "static/media/shade.e31a5ae9.jpeg";